<template>
	<div class="node-wrap">
		<div class="node-wrap-box " :class="{'start-node':hideClose}" @click="(v)=>$emit('node-click',_config)">
			<div class="title" :style="_define?.props?.titleStyle||'background: #3296fa;'">
				<el-icon class="icon">
					<!--					<el-icon-user-filled/>-->
					<component :is="_define.icon"></component>
				</el-icon>
				<span>{{ _define.title }}</span>
				<el-icon class="close" @click.stop="$emit('del-node',_config)" v-if="!hideClose">
					<el-icon-close/>
				</el-icon>
			</div>
			<div class="content">
				<span>{{ _config.description || _config.name }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import FlowAction from './flow-action.vue'
import {getFlow} from "@/components/flow/flow-context";

export default {
	name: 'FlowNode',
	props: {
		hideClose: {
			type: Boolean
		},
		_config: {
			type: Object, default: () => ({})
		},
		_parent: {
			type: Object, default: () => ({})
		},
		_define: {
			type: Object, default: () => ({})
		},
		_index: {
			type: Number
		}
	},
	components: {
		FlowAction
	},
	setup() {
		return {
			getFlow
		}
	}
}
</script>

<style scoped lang="scss">
.node-wrap {
	display: inline-flex;
	width: 100%;
	flex-flow: column wrap;
	justify-content: flex-start;
	align-items: center;
	padding: 0px 50px;
	position: relative;
	z-index: 1;
}

.node-wrap-box {
	display: inline-flex;
	flex-direction: column;
	position: relative;
	width: 220px;
	min-height: 72px;
	flex-shrink: 0;
	background: rgb(255, 255, 255);
	border-radius: 4px;
	cursor: pointer;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);
}

.node-wrap-box::before {
	content: "";
	position: absolute;
	top: -12px;
	left: 50%;
	transform: translateX(-50%);
	width: 0px;
	border-style: solid;
	border-width: 8px 6px 4px;
	border-color: rgb(202, 202, 202) transparent transparent;
	background: #f6f8f9;
}

.node-wrap-box.start-node:before {
	content: none
}

.node-wrap-box .title {
	height: 24px;
	line-height: 24px;
	color: #fff;
	padding-left: 16px;
	padding-right: 30px;
	border-radius: 4px 4px 0 0;
	position: relative;
	display: flex;
	align-items: center;
}

.node-wrap-box .title .icon {
	margin-right: 5px;
}

.node-wrap-box .title .close {
	font-size: 15px;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 10px;
	display: none;
}

.node-wrap-box .content {
	position: relative;
	padding: 15px;
}

.node-wrap-box .content .placeholder {
	color: #999;
}

.node-wrap-box:hover .close {
	display: block;
}
</style>
